export default "__VITE_ASSET__e68a64a6__"